"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collection = Collection;

var _reactVirtual = require("@tanstack/react-virtual");

var _react = _interopRequireWildcard(require("react"));

var _useCollection = require("./useCollection");

var _utils = require("./utils");

var _excluded = ["as", "children", "estimateSize", "exclude", "infiniteScroll", "isLoading", "itemContainer", "items", "onBottom", "parentKey", "parentRef", "passthroughKey", "publicApi"],
    _excluded2 = ["as", "children", "collection", "estimateSize", "exclude", "filter", "filterKey", "infiniteScroll", "isLoading", "itemContainer", "items", "onBottom", "parentKey", "parentRef", "passthroughKey", "publicApi", "virtualize"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function VirtualDynamicCollection(_ref) {
  var _ref$as = _ref.as,
      Container = _ref$as === void 0 ? 'div' : _ref$as,
      children = _ref.children,
      _ref$estimateSize = _ref.estimateSize,
      _estimateSize = _ref$estimateSize === void 0 ? 37 : _ref$estimateSize,
      exclude = _ref.exclude,
      infiniteScroll = _ref.infiniteScroll,
      isLoading = _ref.isLoading,
      ItemContainer = _ref.itemContainer,
      items = _ref.items,
      onBottom = _ref.onBottom,
      parentKey = _ref.parentKey,
      parentRef = _ref.parentRef,
      passthroughKey = _ref.passthroughKey,
      publicApi = _ref.publicApi,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var previousLengthRef = (0, _react.useRef)(items.length);
  var virtualizer = (0, _reactVirtual.useVirtualizer)({
    count: items.length,
    estimateSize: function estimateSize() {
      return _estimateSize;
    },
    getScrollElement: function getScrollElement() {
      return parentRef.current;
    }
  });
  var callbackCaptureRef = (0, _react.useRef)(false);
  (0, _react.useEffect)(function () {
    if (items.length < previousLengthRef.current) {
      virtualizer.scrollToIndex(0, {
        smoothScroll: false
      });
    }

    previousLengthRef.current = items.length;
  }, [items.length]);
  (0, _react.useEffect)(function () {
    if (!isLoading) {
      callbackCaptureRef.current = false;
    }
  }, [isLoading]);
  return /*#__PURE__*/_react.default.createElement(Container, _extends({}, otherProps, {
    style: {
      height: virtualizer.getTotalSize(),
      position: 'relative',
      width: '100%'
    }
  }), virtualizer.getVirtualItems().map(function (virtual) {
    var _item$id;

    var item = items[virtual.index]; // Virtual item to loading

    if (infiniteScroll && items.length !== 0 && virtual.index === items.length - 1 && onBottom && !callbackCaptureRef.current) {
      callbackCaptureRef.current = true;
      onBottom();
    }

    var publicItem = exclude ? (0, _utils.excludeProps)(item, exclude) : item;
    var child = Array.isArray(publicApi) ? children.apply(void 0, [publicItem].concat(_toConsumableArray(publicApi))) : children(publicItem);
    var key = (0, _utils.getKey)(virtual.index, (_item$id = item.id) !== null && _item$id !== void 0 ? _item$id : child.key, parentKey);
    var props = {
      ref: function ref(node) {
        virtual.measureElement(node);
        var ref = child.ref;

        if (typeof ref === 'function') {
          ref(node);
        }
      },
      style: {
        left: 0,
        position: 'absolute',
        top: 0,
        transform: "translateY(".concat(virtual.start, "px)"),
        width: '100%'
      }
    };

    if (ItemContainer) {
      return /*#__PURE__*/_react.default.createElement(ItemContainer, {
        index: virtual.index,
        item: item,
        key: key,
        keyValue: key
      }, /*#__PURE__*/_react.default.cloneElement(child, props));
    }

    return /*#__PURE__*/_react.default.cloneElement(child, _objectSpread(_objectSpread({
      key: key
    }, passthroughKey ? {
      index: virtual.index,
      keyValue: key
    } : {}), props));
  }));
}

function DynamicCollection(_ref2) {
  var children = _ref2.children,
      exclude = _ref2.exclude,
      filter = _ref2.filter,
      filterKey = _ref2.filterKey,
      itemContainer = _ref2.itemContainer,
      items = _ref2.items,
      parentKey = _ref2.parentKey,
      passthroughKey = _ref2.passthroughKey,
      publicApi = _ref2.publicApi;
  var state = (0, _useCollection.useCollection)({
    children: children,
    exclude: exclude,
    filter: filter,
    filterKey: filterKey,
    itemContainer: itemContainer,
    items: items,
    parentKey: parentKey,
    passthroughKey: passthroughKey,
    publicApi: publicApi
  });
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, state.collection);
}

function Collection(_ref3) {
  var as = _ref3.as,
      children = _ref3.children,
      collection = _ref3.collection,
      estimateSize = _ref3.estimateSize,
      exclude = _ref3.exclude,
      filter = _ref3.filter,
      filterKey = _ref3.filterKey,
      infiniteScroll = _ref3.infiniteScroll,
      isLoading = _ref3.isLoading,
      itemContainer = _ref3.itemContainer,
      items = _ref3.items,
      onBottom = _ref3.onBottom,
      parentKey = _ref3.parentKey,
      parentRef = _ref3.parentRef,
      _ref3$passthroughKey = _ref3.passthroughKey,
      passthroughKey = _ref3$passthroughKey === void 0 ? true : _ref3$passthroughKey,
      publicApi = _ref3.publicApi,
      _ref3$virtualize = _ref3.virtualize,
      virtualize = _ref3$virtualize === void 0 ? false : _ref3$virtualize,
      otherProps = _objectWithoutProperties(_ref3, _excluded2);

  if (virtualize && children instanceof Function && items && parentRef) {
    return /*#__PURE__*/_react.default.createElement(VirtualDynamicCollection, _extends({}, otherProps, {
      as: as,
      estimateSize: estimateSize,
      infiniteScroll: infiniteScroll,
      isLoading: isLoading,
      itemContainer: itemContainer,
      items: items,
      onBottom: onBottom,
      parentKey: parentKey,
      parentRef: parentRef,
      passthroughKey: passthroughKey,
      publicApi: publicApi
    }), children);
  }

  var Container = as !== null && as !== void 0 ? as : _react.default.Fragment;
  var content;

  if (collection) {
    content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, collection.collection);
  } else {
    content = /*#__PURE__*/_react.default.createElement(DynamicCollection, {
      exclude: exclude,
      filter: filter,
      filterKey: filterKey,
      itemContainer: itemContainer,
      items: items,
      parentKey: parentKey,
      passthroughKey: passthroughKey,
      publicApi: publicApi
    }, children);
  }

  return /*#__PURE__*/_react.default.createElement(Container, otherProps, content);
}